import * as React from "react";
import { IDistrict, IMunicipality } from "../../../models/IMunicipalityDistrict";
import { TextInput } from "soprasteria-ui-library";

interface IProps {
    municipality: IMunicipality;
    district?: IDistrict;
}

export const MunicipalityInformation: React.FC<IProps> = ({ municipality, district }) => {

    return (
        <>
            <div className="col-6">
                <TextInput label="Kommun" name="readonly" defaultValue={municipality.municipalityName} readonly inlineLabel />
                <TextInput label="Stadsdel" name="readonly" defaultValue={district ? district.districtName : "-"} readonly inlineLabel />

            </div>
        </>

    )
}